import { Component } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatTooltipModule } from '@angular/material/tooltip';
import { ICellRendererParams } from 'ag-grid-community';

@Component({
  selector: 'app-button-cell-renderer-component',
  imports: [MatTooltipModule, MatButtonModule],
  templateUrl: './button-cell-renderer-component.html',
  styleUrl: './button-cell-renderer-component.css',
})
export class ButtonCellRendererComponent {
  params!: any;
  
  agInit(params: ICellRendererParams): void {
    this.refresh(params);
  }

  refresh(params: ICellRendererParams): boolean {
    this.params = params;
    return true;
  }

  onClick() {
    if (this.params.onClick) {
      this.params.onClick(this.params.data, this.params.node.rowIndex);
    }
  }
}
